/* ============================================================================
   THRIVE LIGHTS — Pro Pack card component behavior.
   Two independent interactions:
     1) One-time "pop down" reveal, triggered by real scroll arrival --
        plays once per element, per page load, ease-out ~400ms via CSS
        transition on .tlc-popdown (see thrive-lights-component.css).
        Reduced-motion users get the component visible immediately on load
        instead of waiting on scroll + a disabled transition.
     2) The "What's in the light set" accordion toggle -- always available,
        independent of the entrance reveal.
   The counter (data-thrive-lights-n / data-thrive-lights-bar) is painted by
   the shared ticker already in sections/thrive-promo-bar.liquid
   (window.thriveLightsRepaint) -- nothing to wire here, it queries the whole
   document on every tick and will find these nodes automatically.

   Round-5 fix: the previous IntersectionObserver (rootMargin '0 0 -10% 0',
   threshold 0.15) was firing before the user ever scrolled, on some real
   phones -- the classic zero-area false-positive: while .tlc-popdown is
   collapsed (max-height:0, overflow:hidden) its own bounding rect has ~0
   height, and per the IntersectionObserver spec a zero-area target reports
   intersectionRatio 1 (not 0/0) whenever its rect falls within the root at
   all, so observe() could resolve isIntersecting:true on the very first
   frame -- before any scroll -- if the collapsed element's Y position
   happened to fall inside the initial viewport. Replaced with an explicit
   scroll-position check (element top crosses 80% of viewport height) that
   is gated on a REAL scroll event having fired first, so it can never
   pre-fire on load, on any viewport height, regardless of initial position. */
(function () {
  if (window.__thriveLightsComponent) return;
  window.__thriveLightsComponent = true;

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function revealAll() {
    var nodes = document.querySelectorAll('[data-thrive-lights-popdown]');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-visible');
  }

  var pending = [];
  var scrollBound = false;

  function checkReveal() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var threshold = vh * 0.8;
    for (var i = pending.length - 1; i >= 0; i--) {
      var el = pending[i];
      var rect = el.getBoundingClientRect();
      if (rect.top <= threshold) {
        el.classList.add('is-visible');
        pending.splice(i, 1);
      }
    }
    if (!pending.length && scrollBound) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      scrollBound = false;
    }
  }

  var ticking = false;
  function onScroll() {
    /* This handler firing at all IS the "at least one real scroll event"
       guard -- checkReveal() is never called from bind time, only from
       here, so the component can never pop before the user has actually
       scrolled, even if it happens to start within the reveal zone. */
    if (ticking) return;
    ticking = true;
    (window.requestAnimationFrame || function (fn) { setTimeout(fn, 16); })(function () {
      ticking = false;
      checkReveal();
    });
  }

  function bindReveal() {
    var nodes = document.querySelectorAll('[data-thrive-lights-popdown]');
    if (!nodes.length) return;

    if (reduceMotion) { revealAll(); return; }

    var added = false;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].__thriveLightsObserved) continue;
      nodes[i].__thriveLightsObserved = true;
      pending.push(nodes[i]);
      added = true;
    }

    /* getBoundingClientRect + scroll/resize listeners only -- no
       IntersectionObserver dependency, and critically, checkReveal() is
       NEVER invoked here at bind time. It only ever runs from inside
       onScroll(), which is the guard that prevents any pre-fire on load. */
    if (added && pending.length && !scrollBound) {
      scrollBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
  }

  function bindAccordion() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-thrive-lights-toggle]');
      if (!btn) return;
      var card = btn.closest('.tlc');
      if (!card) return;
      var open = card.getAttribute('data-thrive-lights-expanded') === 'true';
      card.setAttribute('data-thrive-lights-expanded', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      /* Visual open/close is 100% CSS (max-height/opacity on
         [data-thrive-lights-expanded], see thrive-lights-component.css) so
         the collapse transition is never interrupted. aria-hidden (not the
         `hidden` attribute, which would force display:none and kill the
         transition) keeps the closed panel out of the a11y tree. */
      var acc = card.querySelector('[data-thrive-lights-accordion]');
      if (acc) acc.setAttribute('aria-hidden', open ? 'true' : 'false');
    }, false);
  }

  function scan() {
    bindReveal();
  }

  bindAccordion();
  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  /* Desktop rail mounts from an inert <template> after load (same pattern as
     the other lights-bonus scripts in this file family) -- rescan briefly. */
  var n = 0, iv = setInterval(function () { scan(); if (++n > 30) clearInterval(iv); }, 1000);
})();
